import { Input as InputComponent } from '@components-deprecated'

import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import {
  CountrySelector as CountrySelectorComponent,
  CurrencySelector as CurrencySelectorComponent,
} from '@modules-deprecated/app'

interface OrganizationManualDataProps {
  visible?: boolean
}

export const OrganizationManualData = styled.div<OrganizationManualDataProps>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  margin-top: ${Spacing.S16};
`

export const Input = styled(InputComponent)`
  margin-bottom: ${Spacing.S8};
`

export const CurrencySelector = styled(CurrencySelectorComponent)`
  margin-bottom: ${Spacing.S8};
  margin-left: ${Spacing.S8};
`

export const CountrySelector = styled(CountrySelectorComponent)`
  margin-bottom: ${Spacing.S8};
`

export const DualInputsWrapper = styled.div`
  display: flex;

  ${() => Input} {
    width: 50%;
    margin-right: ${Spacing.S8};
    margin-bottom: 0;

    &:last-of-type {
      margin-right: 0;
    }
  }
`

export const InputsSection = styled.div`
  margin-bottom: ${Spacing.S16};
`
